// extracted by mini-css-extract-plugin
export default {"button":"DeepLinkButton_button_AWYhg"};